<div class="border-0 px-md-4 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton />

  <div>

    <!-- HEADER -->
    <div class="card-header glassy-bg shadow-sm border-0 mt-2 rounded-top-lg ms-2 mb-4 p-3">
      <div class="d-flex align-items-center">
        <i class="bx bxs-user fs-3 p-1 bg-green-gov-dark rounded-lg text-dark me-2"></i>

        <div class="d-flex flex-column justify-content-center">
          <p class="fw-bold text-dark mb-0 fs-5 fst-italic d-flex align-items-center pointer"
             @click="open_edit_entity_modal"
             data-bs-toggle="modal"
             data-bs-target="#edit_entity_modal">
            {{ entity_name }}
            <i class="bx bx-edit ms-2 text-primary-dark fs-4"></i>
          </p>

          <span class="text-xs mt-1" :style="{ color: get_status_color(application_status) }">
            <span class="text-xs fw-bold">Application Status :</span>
            {{ application_status }}
          </span>
        </div>
      </div>
    </div>

    <!-- MASTER TABS -->
    <div class="row mb-4 gx-3 ms-1">
      <div class="col-md-4 mb-2">
        <div class="card dashboard-card h-100 p-3 cursor-pointer bg-transparent border shadow rounded-lg"
             :class="active_master_tab === 'profile' ? 'active-card bg-light' : 'bg-white'"
             @click="select_master_tab('profile')">
          <div class="d-flex align-items-center">
            <div class="icon-shape bg-green-gov-dark text-white rounded-circle me-3 d-flex align-items-center justify-content-center">
              <i class="bx bx-user-pin fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Onboarding Profile</h6>
              <p class="mb-0 text-xs text-muted">Your Application Information</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 mb-2">
        <div class="card dashboard-card h-100 p-3 cursor-pointer bg-transparent border shadow rounded-lg"
             :class="active_master_tab === 'documents' ? 'active-card bg-light' : 'bg-white'"
             @click="select_master_tab('documents')">
          <div class="d-flex align-items-center">
            <div class="icon-shape bg-green-gov-dark text-white rounded-circle me-3 d-flex align-items-center justify-content-center">
              <i class="bx bx-file fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Your Uploaded Documents</h6>
              <p class="mb-0 text-xxs text-dark">KYC & Files</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 mb-2">
        <div class="card dashboard-card h-100 p-3 cursor-pointer bg-transparent border shadow rounded-lg"
             :class="active_master_tab === 'compliance' ? 'active-card bg-light' : 'bg-white'"
             @click="select_master_tab('compliance')">
          <div class="d-flex align-items-center">
            <div class="icon-shape bg-green-gov-dark text-white rounded-circle me-3 d-flex align-items-center justify-content-center">
              <i class="bx bx-check-shield fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Your Compliance Status</h6>
              <p class="mb-0 text-xxs text-dark">Risk & Verification</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="ms-3 text-x text-dark fw-700"><i class="bi bi-exclamation-circle me-2"></i>If you wish to make any changes or correct the information in your Application Form , you can do so below. </p>

    <!-- MAIN LAYOUT -->
    <div class="overview-application-container">

      <!-- MOBILE: Tabs (Top Horizontal Scroll) -->
      <div v-if="active_master_tab === 'profile' && filtered_sub_tabs.length > 0"
           class="d-block d-md-none mb-2 overview-tabs-wrapper">

        <div class="mobile-tabs-scroll d-flex gap-2 overflow-auto px-2 py-2">

          <div v-for="tab in filtered_sub_tabs"
               :key="tab.id"
               class="mobile-tab-pill"
               :class="{ active: active_tab === tab.id }"
               @click="select_tab(tab.id)">

            <i :class="get_tab_icon(tab.id)" class="me-1"></i>
            <span class="text-xxs fw-semibold">{{ tab.label }}</span>

          </div>

        </div>
      </div>

      <!-- DESKTOP: Sidebar Tabs -->
      <div v-if="active_master_tab === 'profile' && filtered_sub_tabs.length > 0"
           class="overview-tabs-wrapper d-none d-md-block">

        <div class="overview-vertical-tabs-container">
          <div v-for="tab in filtered_sub_tabs"
               :key="tab.id"
               class="overview-floating-tab"
               :class="{ 'active': active_tab === tab.id }"
               @click="select_tab(tab.id)">

            <div class="overview-floating-tab-inner">
              <div class="d-flex align-items-center">
                <i class="me-2 fs-bold fs-6" :class="get_tab_icon(tab.id)"></i>
                <span class="text-xs fw-semibold">{{ tab.label }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="ms-md-2 w-100 overview-dropdown-column rounded-lg glassy-bg">

        <div class="overview-accordion-container mb-3 border-0 rounded-lg glassy-bg">

          <div v-if="active_master_tab === 'documents'">
            <EntityDocuments />
          </div>

          <div v-else-if="active_master_tab === 'compliance'">
            <OnboardingComplianceComponent :entity_profile_id="entity_profile_id" />
          </div>

          <div v-else-if="active_master_tab === 'profile'">

            <div v-if="content_type === 'dynamic'">
              <RenderSections
                :form_main_section_id="dropdown_forms_id(active_tab)"
                :application_id="application_id"
                :entity_profile_id="entity_profile_id"
                :application_form_id="application_form_id"
              />
            </div>

            <div v-show="active_tab === 'Overview'">
              <ApplicationOverviewDetails />
            </div>

            <div v-show="active_tab === 'Verification'">
              <EntityVerificationResults :entity_profile_id="entity_profile_id" />
            </div>

            <div v-show="active_tab === 'Requests'">
              <RequestedInformationUpdate />
            </div>

            <div v-show="active_tab === 'E-Signing'">
              <ESigning />
            </div>

            <div v-show="active_tab === 'Invoices'">
              <EntityInvoiceOverview />
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- Edit Entity Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_entity_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Edit Trust Name</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                @click="show_edit_entity_modal = false"></button>
      </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label class="form-label text-xxs">Trust Name:</label>
            <input
              type="text"
              v-model.trim="current_edit_entity.name"
              :class="{'is-invalid': entity_name_error}"
              @input="entity_name_error = false"
              class="form-control text-xxs rounded-3 p-2 shadow-sm"
              placeholder="Enter trust name"
              @keyup.enter="save_edited_entity"
            />
            <div v-if="entity_name_error" class="invalid-feedback small">
              Please enter a trust name
            </div>
          </div>
        </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              @click="save_edited_entity"
              :disabled="!current_edit_entity.name?.trim()"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>

      </div>
    </div>
  </div>
</teleport>
